// @flow
import React from 'react'
import styled from 'styled-components'
import type {GridName} from '../entities'
import {observer} from 'mobx-react'
import gridStore from 'stores/grid'

type Props = {|
  gridName: GridName
|}

export default observer(function GridGap(props:Props) {
  const innerStore = gridStore[props.gridName]
  const value = innerStore.gap
  return (
    <Wrapper>
      <button onClick={() => innerStore.setGap(value-1)}>-</button>
      <span>{value}</span>
      <button onClick={() => innerStore.setGap(value+1)}>+</button>
    </Wrapper>
  )
})


const Wrapper = styled.div`
  background: #c3cfd5;
  border: 1px solid grey;
  border-radius: 3px;
  display: flex;
  width: 150px;

  > button {
      flex: 1;
      border: none;
      background: none;
      padding: 5px 10px;
      font-size: 16px;
      cursor: pointer;
  }

  > span {
    flex: 1;
    text-align: center;
    padding: 5px 10px;
    background white;
    border-left: 1px solid grey;
    border-right: 1px solid grey;
  }

`


// WEBPACK FOOTER //
// ./src/config/GridGap.js